import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

let counter = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const push = useCallback((msg, kind = 'success') => {
    const id = ++counter;
    setToasts((t) => [...t, { id, msg, kind }]);
    setTimeout(
      () => setToasts((t) => t.filter((x) => x.id !== id)),
      3200,
    );
  }, []);
  return (
    <ToastContext.Provider value={push}>
      {children}
      <div className="tt-toast-stack">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={'tt-toast ' + (t.kind === 'error' ? 'is-error' : '')}
          >
            <span className="tt-toast-dot" />
            <span>{t.msg}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
